module.exports = __webpack_public_path__ + "img/Feature.18165faa.png";